import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidators } from '../../../shared/form-error/form.validators';
import { Status } from '../../../core/services/http/general/enums/status';
import { getAdditionalControlsForFiltering } from './form.group';
import { RosterUploadFileType } from '../../../core/services/http/roster/enums/roster-upload-file-types';

export function getFormGroup(): UntypedFormGroup {
    return new UntypedFormBuilder().group({
        ...{
            name: [, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
            description: [, [Validators.required, Validators.minLength(3), Validators.maxLength(500)]],
            type: [, [Validators.required, FormValidators.onlyPositiveNumbers]],
            status: [Status.Active, [Validators.required, FormValidators.onlyPositiveNumbers]],
            source: [RosterUploadFileType.GroupOfGroups],
            items: [[]],
            groupSelect: [[], Validators.required],
            adults: [],
        },
        ...getAdditionalControlsForFiltering()
    });
}
